import React from "react";
import IconCaretDown from "../components/DownIcon";
import IconCaretsDown from "../components/DownsIcon";
import { FiChevronLeft, FiChevronsLeft } from "react-icons/fi";

const CustomPagination = ({ total, page, handleChange, dataPerPage }) => {
  const totalPages = Math.ceil(total / dataPerPage);

  const pageNumbers = [];

  // Always add first page
  pageNumbers.push(1);

  // Add ellipsis if current page is not 1 or 2
  if (page > 2) {
    pageNumbers.push("...");
  }

  // Add current page if it's not 1 or the last page
  if (page !== 1 && page !== totalPages) {
    pageNumbers.push(page);
  }

  // Add ellipsis if current page is not the last or second to last
  if (page < totalPages - 1) {
    pageNumbers.push("...");
  }

  // Always add last page if it's not the same as the first page
  if (totalPages > 1) {
    pageNumbers.push(totalPages);
  }

  return (
    <div className="flex md:flex-row flex-col justify-between items-center mt-10 mb-10 px-5 gap-4 text-white">
      {/* <div className="flex gap-5 items-center">
        <p>
          Showing {(page - 1) * dataPerPage + 1} to{" "}
          {Math.min(page * dataPerPage, total)} of {total} entries
        </p>
      </div> */}
      <div className="flex justify-center flex-col">
        <ul className="flex items-center gap-2 m-auto">
          <li>
            <button
              type="button"
              onClick={() => handleChange("First", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === 1
                  ? "pagination-bullet"
                  : "hover:text-white hover:bg-primary bg-white text-black"
              }`}
            >
              <FiChevronsLeft size={20} className="" />
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => handleChange("Previous", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === 1
                  ? "pagination-bullet"
                  : "hover:text-white hover:bg-primary bg-white text-black"
              }`}
            >
              <FiChevronLeft size={20} className="" />
            </button>
          </li>
          {pageNumbers.map((pageNumber, index) => (
            <li key={index}>
              {pageNumber === "..." ? (
                <div className="flex items-center justify-center w-9 h-9 max-w-9">
                  ....
                </div>
              ) : (
                <div
                  style={{ width: "36px" }}
                  className={`h-9 !w-9 flex items-center justify-center rounded-full bg-white text-black cursor-pointer ${
                    page === pageNumber ? "pagination-actives" : ""
                  }`}
                  onClick={() => handleChange("", pageNumber)}
                >
                  {pageNumber}
                </div>
              )}
            </li>
          ))}
          <li>
            <button
              type="button"
              onClick={() => handleChange("Next", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === totalPages
                  ? "pagination-bullet"
                  : "hover:text-white hover:bg-primary bg-white text-black"
              }`}
            >
              <FiChevronLeft size={20} className="rotate-180" />
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => handleChange("Last", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === totalPages
                  ? "pagination-bullet"
                  : "hover:text-white hover:bg-primary bg-white text-black"
              }`}
            >
              <FiChevronsLeft size={20} className="rotate-180" />
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CustomPagination;

// In this code when I have 10 pages and active page is 4 then i want to show pagination like below

// 1....4....10

// if active page is 7

// 1....7....10

// if i have 16 data and active page is 6

// 1....6....16

// if active page is 9

// 1....9....16
